export default __webpack_public_path__ + "static/media/advicegradissuegfx-14.9264bd94.png";